export enum NewDealPlacement {
    Never = 'never',
    AfterTopPicks = 'afterTopPicks',
    AfterSecondBlock = 'afterSecondBlock',
}

export interface LayoutConfig {
    newDealPlacement: NewDealPlacement;
}

export const deriveLayoutConfig = (
    isNewDealsToday: boolean,
    isSemanticArticleCarousel: boolean,
): LayoutConfig => {
    if (!isNewDealsToday) {
        return { newDealPlacement: NewDealPlacement.Never };
    }

    return {
        newDealPlacement: isSemanticArticleCarousel
            ? NewDealPlacement.AfterSecondBlock
            : NewDealPlacement.AfterTopPicks,
    };
};
